module.exports = __webpack_public_path__ + "img/energy_grid_mob.4099382f.svg";